import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Calendar, momentLocalizer } from 'react-big-calendar';
import withDragAndDrop from 'react-big-calendar/lib/addons/dragAndDrop';
import {environment} from '../../../../containers/environment';

import moment from 'moment';

import 'moment/locale/pt-br';
import 'moment/locale/en-gb';

const DragAndDropCalendar = withDragAndDrop(Calendar);

export default class CalendarComponent extends PureComponent {
  static propTypes = {
    events: PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.number,
      title: PropTypes.string,
      allDay: PropTypes.bool,
      start: PropTypes.instanceOf(Date),
      end: PropTypes.instanceOf(Date),
      priority: PropTypes.string,
    })).isRequired,
    small: PropTypes.bool,
    dir: PropTypes.string.isRequired,
  };

  static defaultProps = {
    small: false,
  };

  constructor(props) {
    super(props);
    this.state = {
      events: props.events,
    };
  }

  moveEvent = ({ event, start, end }) => {
    const { events } = this.state;

    const idx = events.indexOf(event);
    const updatedEvent = { ...event, start, end };

    const nextEvents = [...events];
    nextEvents.splice(idx, 1, updatedEvent);

    this.setState({
      events: nextEvents,
    });
  };

  eventStyleGetter = (event) => {
    let color;

    switch (event.priority) {
      case 'high':
        color = '#fa697d';
        break;

      case 'family':
        color = '#4ce1b6';
        break;

      case 'non':
        color = '#70bbfd';
        break;

      case 'ORDERED':
        color = '#70bbfd';
        break;

      case 'RECEIVED':
        color = '#52a2bd';
        break;

      case 'IN_PROCESS':
        color = '#eacf3b';
        break;

      case 'CANCELED':
        color = '#e63345';
        break;

      case 'FINISHED':
        color = '#6bd3a6';
        break;

      default:
        color = '$color-additional';
        break;
    }

    const style = {
      backgroundColor: color,
      border: 'none',
    };

    return {
      style,
    };
  };

  render() {
    const { small, events, dir } = this.props;

    let lng = localStorage.getItem(environment.LANGUAGE);
    if(lng !== null && lng !== undefined && lng === 'br'){
      moment.locale('pt-br');
    }else{
      moment.locale('en');
    }

    let localizer = momentLocalizer(moment);
    const formats = {
      dayFormat: (date, culture) => localizer.format(date, 'DD', culture),
    };

    return (
      <div className={`calendar calendar--auto_size`}>
        <DragAndDropCalendar
          rtl={dir === 'rtl'}
          localizer={localizer}
          events={events}
          views={['month', 'week', 'day']}
          popup
          formats={formats}
          step={60}
          timeslots={1}
          showMultiDayTimes
          onEventDrop={this.moveEvent}
          defaultDate={new Date()}
          eventPropGetter={(this.eventStyleGetter)}
          messages={{
            previous: <span className="lnr lnr-chevron-left" />,
            next: <span className="lnr lnr-chevron-right" />,
            today: <span className="lnr lnr-calendar-full" />,
          }}
        />
      </div>
    );
  }
}
